import { motion } from 'framer-motion';
import { Brain, Ruler, BookOpen, Shield, Award } from 'lucide-react';

const pillars = [
  {
    icon: Brain,
    title: 'Perilaku Sebagai Dasar',
    description: 'Kami melihat cara Anda berpikir dan bereaksi, bukan persona trading yang ingin ditampilkan.'
  },
  {
    icon: Ruler,
    title: 'Segmentasi Berbasis Gaya',
    description: 'Arahkan pengguna ke jalur trading yang lebih sesuai dengan ritme dan psikologinya.'
  },
  {
    icon: BookOpen,
    title: 'Eksekusi Berbasis SOP',
    description: 'Setiap materi disusun dengan langkah yang jelas dan bisa diikuti.'
  },
  {
    icon: Shield,
    title: 'Risiko Lebih Dulu',
    description: 'Fokus utama adalah bertahan dan disiplin sebelum bicara hasil.'
  }
];

const WhyTradersCouncil = () => {
  return (
    <section 
      className="py-24 md:py-32 relative bg-tc-surface/30"
      data-testid="why-traders-council-section"
    >
      {/* Ambient background glow */}
      <div className="absolute inset-0 bg-tc-surface/30 mix-blend-overlay" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-tc-primary/10 border border-tc-primary/20 mb-6">
            <Award className="w-4 h-4 text-tc-primary" />
            <span className="text-sm text-tc-primary font-medium">KENAPA KAMI</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">
            Kenapa Traders Council Asia berbeda
          </h2>
        </motion.div>

        {/* Pillars Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {pillars.map((pillar, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
            >
              <div className="glass-card rounded-2xl p-8 h-full text-center group">
                <div className="w-16 h-16 rounded-2xl bg-tc-primary/10 flex items-center justify-center mx-auto mb-6 group-hover:bg-tc-primary/20 transition-colors">
                  <pillar.icon className="w-8 h-8 text-tc-primary" />
                </div>
                <h3 className="text-lg font-heading font-semibold text-white mb-3">
                  {pillar.title}
                </h3>
                <p className="text-tc-text-secondary text-sm leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Positioning Line */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <div className="inline-block glass-card rounded-2xl px-10 py-8">
            <p className="text-xl md:text-2xl font-heading text-tc-text-secondary">
              Kami tidak mengajarkan <span className="text-white">"cara cepat menang"</span>.
            </p>
            <p className="text-xl md:text-2xl font-heading text-tc-text-secondary mt-2">
              Kami mengajarkan <span className="text-tc-secondary">"cara tidak rugi secara ceroboh"</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyTradersCouncil;
